var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7529 0C13.9479 0 13.8211 4.58227 13.8211 5.52545C13.8211 6.95636 13.8211 11.25 13.8211 11.25H25.9802V12.9686C25.9802 12.9686 13.3202 12.9686 8.99153 12.9686C5.37835 12.9686 0.837891 15.1655 0.837891 24.9005C0.837891 33.8427 4.37971 37.3009 7.95425 37.3009C9.01562 37.3009 12.2015 37.3009 12.2015 37.3009C12.2015 37.3009 12.2015 32.8623 12.2015 31.335C12.2015 28.8391 13.4383 24.2186 19.2043 24.2186C26.4361 24.2186 28.282 24.2186 31.2638 24.2186C33.0374 24.2186 38.0393 23.4477 38.0393 17.6705C38.0393 11.5559 38.0393 9.53864 38.0393 6.66182C38.0397 5.22864 37.7947 0 25.7529 0ZM19.0483 3.84955C20.2583 3.84955 21.2361 4.82682 21.2361 6.03727C21.2361 7.24682 20.2583 8.225 19.0483 8.225C17.8383 8.225 16.8606 7.24727 16.8606 6.03727C16.8606 4.82682 17.8383 3.84955 19.0483 3.84955Z",
    fill: "url(#paint0_linear_458_370)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9235 50.0001C37.7231 50.0001 37.8699 45.3315 37.8699 44.4747C37.8699 43.0438 37.8699 38.7501 37.8699 38.7501H25.6963V37.0315C25.6963 37.0315 38.4381 37.0315 42.6849 37.0315C46.3254 37.0315 50.8385 34.7797 50.8385 25.0997C50.8385 14.4988 46.0485 12.6992 43.7222 12.6992C42.6604 12.6992 39.4749 12.6992 39.4749 12.6992C39.4749 12.6992 39.4749 17.3429 39.4749 18.6651C39.4749 21.161 38.279 25.7815 32.4722 25.7815C25.2404 25.7815 23.6194 25.7815 20.4122 25.7815C18.6431 25.7815 13.6367 26.6433 13.6367 32.3297C13.6367 38.9092 13.6367 40.6319 13.6367 43.3383C13.6367 45.7156 15.0894 50.0001 25.9235 50.0001ZM32.6285 46.1506C31.4185 46.1506 30.4408 45.1729 30.4408 43.9629C30.4408 42.7529 31.4181 41.7751 32.6285 41.7751C33.8381 41.7751 34.8163 42.7529 34.8163 43.9629C34.8163 45.1729 33.8381 46.1506 32.6285 46.1506Z",
    fill: "url(#paint1_linear_458_370)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_370",
    x1: 5.52357,
    y1: 4.46645,
    x2: 30.377,
    y2: 29.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_370",
    x1: 20.6281,
    y1: 20.3988,
    x2: 47.2745,
    y2: 45.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.837891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.3a83899fcc26989e713e0d23f4d7c901.svg";
export { ForwardRef as ReactComponent };